import { useEffect, useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { updateItineraryLandingPageStylesThunk } from 'store/itinerariesItem/thunks';
import { updateLandingPageStylesThunk } from 'store/page/thunks';

export function useCustomStylesWatcher({ pageId, isItinerariesItem }) {
  const dispatch = useDispatch();

  const updateStyles = useCallback(
    (value) => {
      if (isItinerariesItem) return dispatch(updateItineraryLandingPageStylesThunk({ customStyles: value }));
      return dispatch(updateLandingPageStylesThunk({ pageIndex: 0, customStyles: value }));
    },
    [dispatch, isItinerariesItem],
  );

  const localStorageUpdated = useCallback(
    (event) => {
      if (event.key === 'customStyles') updateStyles(event.newValue);
    },
    [updateStyles],
  );

  useEffect(() => {
    window.localStorage.setItem('customCurrentPageId', pageId);
    window.addEventListener('storage', (event) => localStorageUpdated(event));
    return () => {
      window.removeEventListener('storage', (event) => localStorageUpdated(event));
      window.localStorage.removeItem('customStyles');
      window.localStorage.removeItem('customCurrentPageId');
    };
  }, [localStorageUpdated, pageId]);
}
